import React, { useEffect, useState } from 'react';
import TweetList from './components/TweetList';
import Header from './components/Header';
import PostTweet from './components/PostTweet';
import './style/App.css';

function App() {
  return (
    <div className="content-container">
      <Header />
      <div className="App">
        <PostTweet/>
        <TweetList/>
      </div>
    </div>
  );
}

export default App;
